module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-57x57-precomposed-1c50158cbec911c74374aff55b636566.png";